import PropTypes from 'prop-types';
import React from 'react';

const ComponentSwitch = ({
  component,
  currentUrl,
  bLUrls,
  selectedCompany,
  wLCompanies,
}) => {
  const cleanCurrentUrl = currentUrl?.split('/')[2];
  const isUrlAllowed = !bLUrls?.some(u => u === cleanCurrentUrl);
  const isCompanyWhitelisted = wLCompanies
    ? wLCompanies?.some(c => c === selectedCompany)
    : true;
  return isUrlAllowed && isCompanyWhitelisted ? <>{component}</> : null;
};

ComponentSwitch.propTypes = {
  component: PropTypes.element.isRequired,
  selectedCompany: PropTypes.string,
  wLCompanies: PropTypes.array,
  currentUrl: PropTypes.string,
  bLUrls: PropTypes.array,
};

export default ComponentSwitch;
